import { useMemo } from 'react';
import { SystemLanguageType } from 'constant/language';
import { getLocalStorageLanguage } from 'commons';
import { BRAND_LIST, BrandType, getBrandList } from 'constant/brand';

export type { BrandType };

const useBrandList = (lang?: SystemLanguageType) => {
  const language = getLocalStorageLanguage();
  const innerLang = lang || language;

  const list = useMemo(() => getBrandList(innerLang), [innerLang]);

  return {
    BrandList: list,
    DefaultBrand: list[0],
    SourceBrandList: BRAND_LIST,
  };
};

export default useBrandList;
